// extracted by mini-css-extract-plugin
export default {"legend":"MapLegend_legend__cX-BX","circle":"MapLegend_circle__sS7Bv","sendCircle":"MapLegend_sendCircle__7J68G","receiveCircle":"MapLegend_receiveCircle__W9kDK"};